const reduced = useMediaQuery("(prefers-reduced-motion: reduce)");

export const usePrefersReducedMotion = () => {
  return {
    motionReduced: computed(() => {
      return reduced.value;
    }),
  };
};
